import { combineReducers } from 'redux';
import collection from './Collection/reducer';
import sortPreference from './Sidebar/reducer';
export default combineReducers({
  collection,
  sortPreference,
});
